/** @format */

import {useState, useEffect} from 'react';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

interface Props {
  startDate: any;
  endDate: any;
  onConfirm: (startDate: Date, endDate: Date) => void;
  onClear?: () => void;
}

const DateRange = (props: Props) => {
  const [dateRange, setDateRange] = useState([props.startDate, props.endDate]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (startDate && endDate) {
      props.onConfirm(startDate, endDate);
    }
  }, [dateRange, endDate, props, startDate]);

  const handleChange = (update: [Date | null, Date | null]) => {
    setDateRange(update);

    // Если обе даты null (сброс), вызываем onClear
    if (!update[0] && !update[1] && props.onClear) {
      props.onClear();
    }
  };

  return (
    <DatePicker
      selectsRange
      startDate={startDate}
      endDate={endDate}
      portalId='root'
      onChange={handleChange}
      isClearable
      placeholderText='Выбрать'
    />
  );
};

export default DateRange;
